<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>赛项管理</el-breadcrumb-item>
      <el-breadcrumb-item>设置赛道</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="4" style="width:360px !important;margin-right: 20px;">
          <el-select
            v-model="queryInfo.MatchID"
            placeholder="请选择赛项名称"
            clearable
            style="width:360px !important"
          >
            <el-option
              v-for="item in matchNameoptions"
              :key="item.MatchID"
              :label="item.MatchName"
              :value="item.MatchID"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-input
            placeholder="请输入赛道名称"
            v-model="queryInfo.TrackName"
            clearable
            @clear="getSettrackList(1)"
          >
          </el-input>
        </el-col>
        <el-col :span="2">
          <el-button
            icon="el-icon-search"
            type="primary"
            @click="getSettrackList(1)"
            >搜索</el-button
          >
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="showAddSettrack"
            >添加赛道</el-button
          >
        </el-col>
      </el-row>

      <!-- 表格列表 -->
      <el-table :data="pagedata" style="width: 100%" border stripe size="mini">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="MatchName" label="赛事名称" width="280">
        </el-table-column>
        <el-table-column prop="TrackName" label="赛道名称"> </el-table-column>
        <el-table-column prop="TrackSerialNum" label="赛道序号">
        </el-table-column>
        <el-table-column prop="TrackNumber" label="赛道号"> </el-table-column>
        <el-table-column
          prop="AddDateTime"
          label="添加日期"
          :formatter="dataFormat"
        >
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="showEditSettrack(scope.row)"
              >修改</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="deleteSettrack(scope.row.TrackID)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>

      <!-- 添加 -->
      <el-dialog
        title="添加赛道"
        :visible.sync="addDialogVisible"
        width="30%"
        @close="addresetFields"
      >
        <el-form
          :model="addForm"
          :rules="addRules"
          ref="addFormRef"
          label-width="100px"
        >
          <el-form-item label="赛事名称" prop="MatchID">
            <el-select v-model="addForm.MatchID" placeholder="请选择" style="width: 370px !important">
              <el-option
                v-for="item in matchNameoptions"
                :key="item.MatchID"
                :label="item.MatchName"
                :value="item.MatchID"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="赛道名称" prop="TrackName">
            <el-input v-model="addForm.TrackName"></el-input>
          </el-form-item>
          <el-form-item label="赛道号" prop="TrackSerialNum">
            <el-input v-model="addForm.TrackNumber"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addSettrack()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 修改 -->
      <el-dialog
        title="修改赛道"
        :visible.sync="editDialogVisible"
        width="30%"
        @close="editresetFields"
      >
        <el-form
          :model="editForm"
          :rules="editRules"
          ref="editFormRef"
          label-width="100px"
        >
          <el-form-item label="赛事名称" prop="MatchID">
            <el-select v-model="editForm.MatchID" style="width: 370px !important" placeholder="请选择">
              <el-option
                v-for="item in matchNameoptions"
                :key="item.MatchID"
                :label="item.MatchName"
                :value="item.MatchID"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="赛道名称" prop="TrackName">
            <el-input v-model="editForm.TrackName"></el-input>
          </el-form-item>
          <el-form-item label="赛道号" prop="TrackSerialNum">
            <el-input v-model="editForm.TrackNumber"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="editSettrack()">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 获取列表
      queryInfo: {
        // 查询参数
        MatchID: '',
        TrackName: '',
        // 当前页码
        pageNum: 1,
        // 每页显示条数
        pageSize: 10
      },
      pagedata: [],
      total: 0,
      // 添加弹框显示状态
      addDialogVisible: false,
      // 修改弹框显示状态
      editDialogVisible: false,
      // 评审须知弹框显示状态
      noticeDialogVisible: false,
      // 弹窗默认标题
      dialogTitle: '',
      // 添加表单
      addForm: {
        MatchID: '',
        TrackName: '',
        TrackSerialNum: '',
        TrackNumber: '',
        AddDateTime: ''
      },
      // 修改表单
      editForm: {},
      // 添加表单验证
      addRules: {
        MatchID: [
          {
            required: true,
            message: '请选择赛事名称',
            trigger: 'change'
          }
        ],
        TrackName: [
          {
            required: true,
            message: '请输入赛道名称',
            trigger: 'blur'
          }
        ],
        TrackNumber: [
          {
            required: true,
            message: '请输入赛道号',
            trigger: 'blur'
          }
        ]
      },
      // 修改表单验证
      editRules: {
        MatchID: [
          {
            required: true,
            message: '请选择赛事名称',
            trigger: 'change'
          }
        ],
        TrackName: [
          {
            required: true,
            message: '请输入赛道名称',
            trigger: 'blur'
          }
        ],
        TrackNumber: [
          {
            required: true,
            message: '请输入赛道号',
            trigger: 'blur'
          }
        ]
      },
      // 赛事名称下拉选项
      matchNameoptions: [
        {
          value: '1',
          label: '赛事1'
        },
        {
          value: '2',
          label: '赛事2'
        }
      ]
    }
  },
  created() {
    //   默认获取列表
    this.getSettrackList(1)
    this.getAllMatch()
  },
  methods: {
    //   获取赛道列表
    async getSettrackList(newPage) {
      this.queryInfo.pageNum = newPage
      const { data: res } = await this.$http.get('/api/Track/GetAllTracks', {
        params: this.queryInfo
      })
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.pagedata = res.Data.tracks
      this.total = res.Data.total
    },
    //   下拉获取所有赛事
    async getAllMatch() {
      const { data: res } = await this.$http.get('/api/Match/GetMatchs')
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.matchNameoptions = res.Data.matchs
    },
    // 监听pagesize 切换显示多少条 事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
      this.getSettrackList(1)
    },
    // 监听点击了第几页 事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage
      this.getSettrackList(newPage)
    },
    // 关闭弹窗重置表单验证
    addresetFields() {
      this.addForm = {
        MatchID: '',
        TrackName: '',
        TrackSerialNum: ''
      }
      this.$refs.addFormRef.resetFields()
    },
    // 关闭弹窗重置表单验证
    editresetFields() {
      this.editForm = {
        MatchID: '',
        TrackName: '',
        TrackSerialNum: ''
      }
      this.$refs.editFormRef.resetFields()
    },
    // 显示创建赛事弹窗
    showAddSettrack() {
      // 打开弹窗
      this.addDialogVisible = true
    },
    // 显示修改赛事弹窗
    showEditSettrack(row) {
      this.editForm = row
      this.editDialogVisible = true
    },
    // 添加
    addSettrack() {
      this.$refs.addFormRef.validate(async (valid) => {
        // 验证不通过跳出
        if (!valid) return false
        // 发起添加请求
        const { data: res } = await this.$http.post(
          '/api/Track/EditTrack',
          this.addForm
        )
        // 判断状态码
        if (res.StatusCode !== 1) return this.$message.error(res.Msg)
        // 成功提示
        this.$message.success(res.Msg)
        // 关闭弹窗
        this.addDialogVisible = false
        // 刷新列表
        this.getSettrackList(1)
      })
    },
    // 修改
    editSettrack() {
      this.$refs.editFormRef.validate(async (valid) => {
        // 验证不通过跳出
        if (!valid) return false
        // 发起添加请求
        const { data: res } = await this.$http.post(
          '/api/Track/EditTrack',
          this.editForm
        )
        // 判断状态码
        if (res.StatusCode !== 1) return this.$message.error(res.Msg)
        // 成功提示
        this.$message.success(res.Msg)
        // 关闭弹窗
        this.editDialogVisible = false
        // 刷新列表
        this.getSettrackList(1)
      })
    },
    // 删除
    async deleteSettrack(id) {
      console.log(id)
      // 提示是否确认删除
      const res = await this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => {
        return err
      })
      if (res !== 'confirm') return this.$message.info('已取消删除')
      // 再次提示
      const res2 = await this.$confirm(
        '此操作会删除所有关联数据，删除后无法恢复！请谨慎操作！！！确认删除吗?',
        '警告',
        {
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
          type: 'warning',
          customClass: 'messageColor'
        }
      ).catch((err) => {
        return err
      })
      if (res2 !== 'confirm') return this.$message.info('已取消删除')

      const { data: resdel } = await this.$http.post(
        '/api/Track/DeleteTrack?trackID=' + id
      )
      if (resdel.StatusCode !== 1) return this.$message.error('删除失败')
      this.$message.success('删除成功')
      this.getSettrackList(this.queryInfo.pageNum)
    },
    // 时间格式化
    dataFormat: function (row, column) {
      var date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang="less" scoped>
</style>
